(function () {
    'use strict';

    angular.module("imApp").factory("prodSizesService", ['$ihttp', function ($ihttp) {
        let service = {
            getProductSize: function (parms) {
                return $ihttp.post({
                    method: 2168,
                    parameters: parms || {}
                });
            },
            listProductSizes: function (parms) {
                return $ihttp.post({
                    method: 2169,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
